function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, useMemo } from 'react';
import styles from './RecordCompareLayout.module.scss';
import RecordCompareStateContext from '../../RecordCompareStateContext';
import cs from 'classnames';
export function Layout(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.layout, " ").concat(className)
  }, children);
}
export function Row(_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  var _useContext = useContext(RecordCompareStateContext),
    cardView = _useContext.cardView;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.row, " ").concat(className ? className : '').concat(cardView ? " ".concat(styles['card-view']) : '')
  }, children);
}
export function Column(_ref3) {
  var id = _ref3.id,
    className = _ref3.className,
    children = _ref3.children,
    highlight = _ref3.highlight,
    span = _ref3.span,
    tabbed = _ref3.tabbed;
  var _useContext2 = useContext(RecordCompareStateContext),
    cardView = _useContext2.cardView,
    isMergeEnabled = _useContext2.isMergeEnabled;
  var outerStyle = useMemo(function () {
    return span ? {
      flexGrow: span
    } : {};
  }, [span]);
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.column, className, _defineProperty(_defineProperty({}, styles.highlight, highlight), styles['card-view'], cardView)),
    style: outerStyle,
    tabIndex: tabbed ? 0 : -1
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cs('layout-column', styles['column-inner'], _defineProperty(_defineProperty({}, styles['column-inner-center'], span), styles['card-view'], cardView))
  }, cardView ? /*#__PURE__*/React.createElement("span", {
    className: cs(styles['column-inner-wrapper'], styles['card-view'], _defineProperty({}, styles['read-only'], !isMergeEnabled))
  }, children) : children));
}
export default Layout;